import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";
import {getUserSourceDisplay, UserSource} from "../../tracking/tracking_utils/user_source";

export enum GAAuthEventName {
    SIGN_UP = "sign_up",
    LOGIN = "login"
}

export enum GAAuthEventCategory {
    REGISTRATION_FORM = "registration_form",
    LOGIN_FORM = "login_form",
    LEAD_FORM = "lead_form",
    GOOGLE_ONE_TAP = "google_one_tap"
}

enum GAAuthEventLabel {
    GOOGLE = "google",
    FACEBOOK = "facebook",
    EMAIL = "email"
}

interface IGoogleAuthEventParams {
    event: GAAuthEventName;
    eventCategory: GAAuthEventCategory;
    userSource: UserSource;
    source: string | null;
}

interface IFacebookAuthEventParams {
    event: GAAuthEventName;
    eventCategory: Exclude<GAAuthEventCategory, GAAuthEventCategory.GOOGLE_ONE_TAP>;
    userSource: UserSource;
    source: string | null;
}

interface IEmailAuthEventParams {
    event: GAAuthEventName;
    eventCategory: Exclude<GAAuthEventCategory, GAAuthEventCategory.GOOGLE_ONE_TAP>;
    userSource: UserSource;
    source: string | null;
}

const getCustomLabel = (source: string | null, userSource: UserSource) => {
    if (source) {
        return source;
    }

    return getUserSourceDisplay(userSource);
};

const googleAuthEvent = (params: IGoogleAuthEventParams) => {
    hitGoogleTagManager({
        event: params.event,
        event_category: params.eventCategory,
        event_label: GAAuthEventLabel.GOOGLE,
        custom_label: getCustomLabel(params.source, params.userSource)
    });
};

const facebookAuthEvent = (params: IFacebookAuthEventParams) => {
    hitGoogleTagManager({
        event: params.event,
        event_category: params.eventCategory,
        event_label: GAAuthEventLabel.FACEBOOK,
        custom_label: getCustomLabel(params.source, params.userSource)
    });
};

const emailAuthEvent = (params: IEmailAuthEventParams) => {
    hitGoogleTagManager({
        event: params.event,
        event_category: params.eventCategory,
        event_label: GAAuthEventLabel.EMAIL,
        custom_label: getCustomLabel(params.source, params.userSource)
    });
};

export const authAnalytics = {
    gtm: {
        googleAuthEvent,
        facebookAuthEvent,
        emailAuthEvent
    }
};
